const TAB_CONTEXT_PREFIX = "jk_tab_context:";

let memoryTabContextId = "";

function createTabContextId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  const randomPart = Math.random().toString(16).slice(2).padEnd(12, "0").slice(0, 12);
  return `00000000-0000-4000-8000-${randomPart}`;
}

function isUuid(value) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    String(value || "").trim()
  );
}

export function getTabContextId() {
  if (memoryTabContextId) return memoryTabContextId;

  if (typeof window !== "undefined") {
    const existingName = String(window.name || "");
    if (existingName.startsWith(TAB_CONTEXT_PREFIX)) {
      const existingId = existingName.slice(TAB_CONTEXT_PREFIX.length);
      if (isUuid(existingId)) {
        memoryTabContextId = existingId;
        return memoryTabContextId;
      }
    }
  }

  memoryTabContextId = createTabContextId();
  if (typeof window !== "undefined") {
    window.name = `${TAB_CONTEXT_PREFIX}${memoryTabContextId}`;
  }
  return memoryTabContextId;
}
